// extracted by mini-css-extract-plugin
export default {"body":"nqg0vcWuo3ac30vtaM1W","avatar":"mlOQ8M0kltQKSa9AYVdp","text":"qTY3s6NNeRXV3Km3GVJz"};